/* Libraries */
import color from 'color';

/* Styles */
import { black, pinkA100, white } from './colors';
import DefaultTheme from './DefaultTheme';

/* Types */
import type { Theme } from '../types';

const DarkTheme: Theme = {
	...DefaultTheme,
	dark: true,
	mode: 'adaptive',
	colors: {
		...DefaultTheme.colors,
		primary: '#BB86FC',
		accent: '#03dac6',
		background: '#333333',
		surface: '#121212',
		error: '#CF6679',
		onSurface: white,
		text: white,
		disabled: color(white).alpha(0.38).rgb().string(),
		placeholder: color(white).alpha(0.54).rgb().string(),
		backdrop: color(black).alpha(0.5).rgb().string(),
		notification: pinkA100,
	},
};

export default DarkTheme;
